<template>
  <ProLayout
    :menu="menu"
    layout="TB"
    contentPadding="24"
    :topBarZIndex="1021"
    :headerZIndex="1020"
  >
    <template #topBar><HeaderTop></HeaderTop></template>
    <template #headerLeft>
      <slot name="headerLeft">
        <div class="basic-layout__title">3D H5 平台</div>
      </slot>
    </template>
    <template
      v-if="currentUser.id"
      #headerRight
    >
      <a-icon
        class="basic-layout__icon"
        type="bell"
      />
      <div class="user-wrapper">
        <a-dropdown>
          <span class="action">
            <a-avatar
              class="basic-layout__avatar"
              :size="24"
            >
              {{
              username[0].toLocaleUpperCase()
              }}
            </a-avatar>
          </span>
          <a-menu
            slot="overlay"
            class="user-dropdown-menu-wrapper"
          >
            <a-menu-item class="user-info">{{ username }}</a-menu-item>
            <a-menu-divider />
            <a-menu-item>
              <router-link :to="{
                  name: 'Account',
                }">个人中心</router-link>
            </a-menu-item>
            <a-menu-divider />
            <a-menu-item>
              <a
                href="javascript:;"
                @click="handleLogout"
              >
                <a-icon type="poweroff" />&nbsp;
                <span>退出登录</span>
              </a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </template>
    <template>
      <slot></slot>
    </template>
  </ProLayout>
</template>

<script>
import { mapState } from 'vuex';
import { ProLayout } from '@mbs/pro-layout';
import '@mbs/pro-layout/esm/style/index.less';
import HeaderTop from '@/components/layouts/components/HeaderTop/Index.vue';

export default {
  name: 'BasicLayout',
  components: {
    ProLayout,
    HeaderTop,
  },
  props: {
    menu: {
      type: Boolean,
      default: undefined,
    },
  },
  computed: {
    ...mapState(['currentUser']),
    username() {
      return this.currentUser.chineseName || this.currentUser.username;
    },
  },
  methods: {
    handleLogout() {
      this.$confirm({
        title: '系统提示',
        content: '你确定要退出登录吗？',
        onOk: () => {
          this.$store.dispatch('setAccessToken', {});
          window.location.reload();
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.basic-layout {
  &__title {
    padding: 0 20px;
    color: @gray-9;
    .font-size-16;
  }
  &__icon {
    display: inline-block;
    padding: 0 @padding-xs;
    color: @text-color;
    font-size: 20px;
    vertical-align: middle;
    cursor: pointer;
  }
  &__avatar {
    background: @primary-color;
  }
}
.user-wrapper {
  display: inline-block;
  padding-right: @padding-md;
  .action {
    display: inline-block;
    height: 100%;
    padding: 0 @padding-xs;
    cursor: pointer;
    transition: all 0.3s;
  }
}
.user-dropdown-menu-wrapper {
  margin-top: @padding-md;
  .ant-dropdown-menu-item {
    padding: 5px 20px;
  }
  .user-info {
    &:hover {
      background-color: #ffffff;
    }
    &__description {
      width: 100px;
      font-size: @font-size-sm;
      color: @text-color-secondary;
    }
  }
}
</style>
